// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"017ceb76","277":"26f8c6a8","453":"021f48d9","482":"c9bb9fc8","487":"0a24c8f5","573":"67b6a2ca","690":"ae4a22fb","727":"3cef7273","868":"ca9a16e1","940":"3d5bc649","964":"070d1410"}[chunkId] + ".chunk.js";
};